import React, { useId } from "react";
import { Button, FileBadge, FileDropZone } from "@sscs/ui";
import { UploadIcon } from "@sscs/ui/icons";

type FileUploadProps = {
  title: string;
  file: File | null;
  sha256: string | null;
  onFileSelect: (file: File) => void;
  onFileRemove: () => void;
};

const FileUpload = ({
  title,
  file,
  sha256,
  onFileSelect,
  onFileRemove,
}: FileUploadProps): React.JSX.Element => {
  const inputId = useId();

  if (file) {
    return (
      <FileBadge
        path={file.name}
        size={file.size}
        sha256={sha256}
        onRemove={onFileRemove}
      />
    );
  }

  return (
    <FileDropZone
      size="medium"
      onDrop={([dropped]) => {
        if (dropped) onFileSelect(dropped);
      }}
      icon={<UploadIcon size="inherit" />}
      title={title}
      description="Drag and drop a file here, or choose one from this device."
      dropTitle="Drop to upload"
    >
      <label htmlFor={inputId}>
        <input
          hidden
          id={inputId}
          type="file"
          multiple={false}
          onChange={(event) => {
            const selected = event.target.files?.[0];
            if (selected) onFileSelect(selected);
          }}
        />
        <Button color="primary" component="span" startIcon={<UploadIcon />}>
          Choose file
        </Button>
      </label>
    </FileDropZone>
  );
};

export default FileUpload;
